/* eslint-disable react/prop-types */
import clsx from 'clsx'
import type { DateCell } from '../types'
import { formatDate } from '@bpinternal/shared'
import { createRenderer } from './renderer'

import { Popover, PopoverTrigger, PopoverContent } from '../../../shadcn/popover'
import { Calendar } from '../../../shadcn/calendar'
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../shadcn/tooltip'
import { cn } from '../../../../lib/utils'
import { NOL } from './null'
import { format } from 'date-fns'
import { Input } from '../../../shadcn'
import { EditorFooter } from './utils'
import { useCallback } from 'react'

export const Dates = createRenderer<DateCell>({
  View: ({ className, cell }) => {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    return (
      <div className={clsx(className, 'focus-visible:outline-none', { 'computed-cell': cell.computed })}>
        {cell.value ? (
          <Tooltip>
            <TooltipTrigger>
              {formatDate(cell.value, { format: 'short', includeTime: true, relative: cell.value > yesterday })}
            </TooltipTrigger>
            <TooltipContent className="bg-black/80" side="bottom" sideOffset={10}>
              {formatDate(cell.value, { format: 'long', includeTime: true })}
            </TooltipContent>
          </Tooltip>
        ) : (
          <NOL />
        )}
      </div>
    )
  },
  Editor: ({ cell, className, onCellChange, ...props }) => {
    const date = cell.value
    const handleDateSelect = (selectedDate: Date | undefined) => {
      if (selectedDate) {
        onCellChange?.(props.row, {
          type: 'date',
          value: selectedDate,
        })
      }
    }

    const handleSave = useCallback(() => {
      props.onClose(true)
    }, [props.onClose])

    return (
      <Popover open={true}>
        <PopoverTrigger asChild>
          <div className={clsx(className, 'px-2 focus-visible:outline-none', { 'computed-cell': cell.computed })}>
            {cell.value ? formatDate(cell.value, { format: 'short', includeTime: true }) : <NOL />}
          </div>
        </PopoverTrigger>
        <PopoverContent {...props} className={cn('w-auto p-0')}>
          <div className="flex flex-col">
            <Calendar mode="single" selected={date ?? undefined} onSelect={handleDateSelect} initialFocus />
            <div className="flex p-2 pt-0">
              <Input
                className="w-fit"
                type="time"
                value={date ? format(date, 'HH:mm') : undefined}
                onChange={(e) => {
                  onCellChange?.(props.row, {
                    type: 'date',
                    value: e.target.value ? new Date((date ?? new Date()).toDateString() + ' ' + e.target.value) : null,
                  })
                }}
              />
            </div>
          </div>
          <EditorFooter handleSave={handleSave} />
        </PopoverContent>
      </Popover>
    )
  },
})
